<template>
  <div class="wrapper inline-grid grid-cols-9 col-gap width-full">
    <header class="page-title col-span-6 col-start-2">
      <h1 class="header-one">
        Flex shrink
      </h1>
      <p class="page-title__sub">
        Utility classes for flex shrink.
      </p>
    </header>
    <section class="section col-span-6 col-start-2">
      <div class="table">
        <table>
          <thead>
            <tr>
              <th>Class name</th>
              <th>Properties</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <code class="code__class">.shrink-0</code>
              </td>
              <td>
                <code class="code__prop">flex-shrink: 0;</code>
              </td>
            </tr>
            <tr>
              <td>
                <code class="code__class">.shrink-1</code>
              </td>
              <td>
                <code class="code__prop">flex-shrink: 1;</code>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>
    <section class="section col-span-6 col-start-2">
      <header class="section__title">
        <h2 class="header-two">
          Usage
        </h2>
      </header>
      <p>
        <code>.shrink-0</code> can be used if you want the flex item to always take the space it requires.
      </p>
      <p>
        If you require flex items to shrink with the flex parent, use <code>.shrink-1</code>.
      </p>
      <code-block>
        <template #code>
          <pre class="language-html" rel="html">
          <code>&lt;div class="flex..."&gt;
  &lt;span class="shrink-1...">&lt;span>
  &lt;span class="shrink-0...">&lt;span>
  &lt;span class="shrink-1...">&lt;span>
&lt;/div&gt;</code>
          </pre>
        </template>
      </code-block>
      <preview class="preview--padding-10">
        <template #preview>
          <div class="preview__wrapper flex align-items-start width-full tiara">
            <div class="shrink-1 flex flex-col">
              <span class="label flex margin-10 margin-bottom-5">
                <code>.shrink-1</code>
              </span>
              <span class="flex justify-content-center padding-13
              margin-10 margin-top-0 bg-selective-yellow text-center"
              >
                Element will shrink with parent
              </span>
            </div>
            <div class="shrink-0 flex flex-col">
              <span class="label flex margin-10 margin-bottom-5">
                <code>.shrink-0</code>
              </span>
              <span class="flex justify-content-center padding-13
              margin-10 margin-top-0 bg-selective-yellow text-center"
              >
                Element wont shrink
              </span>
            </div>
            <div class="shrink-1 flex flex-col">
              <span class="label flex margin-10 margin-bottom-5">
                <code>.shrink-1</code>
              </span>
              <span class="flex justify-content-center padding-13
              margin-10 margin-top-0 bg-selective-yellow text-center"
              >
                Element will shrink with parent
              </span>
            </div>
          </div>
        </template>
      </preview>
    </section>
  </div>
</template>

<script>
import Preview from '@/components/Preview';
import CodeBlock from '@/components/Code-Block';

export default {
  name: 'Shrink',
  components: {
    Preview,
    CodeBlock,
  },
};
</script>
